const CheckMarkIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
  >
    <circle cx="14" cy="14" r="13.5" stroke="#2E66FF" />
    <path
      d="M6.99976 13.7084L11.9581 18.6667L21.2914 9.33337"
      stroke="#2E66FF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CheckMarkIcon;
